<template>
  <!--  预算编制-->
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed; top: 0; z-index: 999; width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="inputForm.code" label="调整单编号" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.name" label="调整单名称" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.createByName" label="制单人" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.createDeptName" label="制单部门" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.remarks" label="备注" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <div style="padding-left: 16px;" v-show="inputForm.attachList&&inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index"
             @click="$viewAttach(file)">{{ file.name }}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item :title="inputForm.isHq === '0' ? '事项单信息' : '会签单信息'" name="2">
        <van-field v-model="inputForm.eventCode" :label="inputForm.isHq === '0' ? '非合同事项单编号' : '会签单编号'" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.eventName" :label="inputForm.isHq === '0' ? '非合同事项单名称' : '会签事项'" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.eventTypeName" :label="inputForm.isHq === '0' ? '非合同事项单类型' : '会签单类型'" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.unitPriceTypeName" :label="inputForm.isHq === '0' ? '事项单价款类型' : '会签单价款类型'" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.mainstayTypeName" label="费用承担主体类型" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.mainstayObjName" label="费用承担对象" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-show="inputForm.mainstayType=='1'" v-model="inputForm.mainstayCompanyName" label="费用承担公司" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.projectName" label="所属项目" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.paymentCompanyName" label="付款公司" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.eventAmount" :label="inputForm.isHq === '0' ? '事项单应付款金额(元)' : '会签单应付款金额（元）'" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.supplierTypeName" label="受款人类型" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.supplierName" label="受款人名称" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.effectiveStartDate" :label="inputForm.isHq === '0' ? '非合同事项单期限起' : '会签单期限起'" label-width="100px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.effectiveEndDate" :label="inputForm.isHq === '0' ? '非合同事项单期限止' : '会签单期限止'" label-width="100px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>
      <van-collapse-item v-if="inputForm.isHq === '0'" title="基本信息调整" name="3">
        <div class="m-form" v-for="(data, index) in inputForm.costEventAdjustDetailList" :key="index">
          <div class="m-row">
            <div class="m-row-text">调整内容</div>
            <div class="m-row-content large-content">{{ getAdjustTypeName(data.name) }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">调整前</div>
            <div class="m-row-content large-content">{{ data.originalLabel }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">调整后</div>
            <div class="m-row-content large-content">
              {{ data.adjustLabel }}
            </div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="预算信息" name="4" v-if="inputForm.unitPriceType!=='3'">
        <van-field v-model="inputForm.budgetControlName" label="预算控制" label-width="100px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-if="inputForm.budgetControl === '2'" v-model="inputForm.specialProjectName" label="专项预算项目"
                   label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <div v-if="inputForm.budgetControl === '1'" v-for="(data, index) in inputForm.costBudgetDTOList" :key="index"
             style="margin-bottom: 10px">
          <div class="m-form">
            <div class="m-row" v-if="inputForm.unitPriceType!=='3'">
              <div class="m-row-text">预算年度</div>
              <div class="m-row-content">{{ data.budgetAnnual }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算科目编号</div>
              <div class="m-row-content">{{ data.budgetSubjectCode }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算科目名称</div>
              <div class="m-row-content">{{ data.budgetSubjectFullName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算金额(元)</div>
              <div class="m-row-content">{{
                  data.isBudgetExists == 1 ? Number(data.budgetAmount).toFixed(2) : '-'
                }}
              </div>
            </div>
            <div class="m-row">
              <div class="m-row-text">预算已使用金额(元)</div>
              <div class="m-row-content">{{
                  data.isBudgetExists == 1 ? Number(data.budgetUsedAmount).toFixed(2) : '-'
                }}
              </div>
            </div>
            <div class="m-row" v-if="inputForm.unitPriceType=='4'">
              <div class="m-row-text">预算分摊金额(元)</div>
              <div class="m-row-content">{{ Number(data.budgetApportionAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row" v-if="inputForm.unitPriceType=='4'">
              <div class="m-row-text">预算余额(元)</div>
              <div class="m-row-content">{{
                  data.isBudgetExists == 1 ? Number((data.budgetAmount || 0) - (data.budgetUsedAmount || 0) - (data.budgetApportionAmount || 0)).toFixed(2) : '-'
                }}
              </div>
            </div>
            <div class="m-row" v-if="inputForm.unitPriceType=='2'">
              <div class="m-row-text">原预算分摊金额(元)</div>
              <div class="m-row-content">{{
                  data.isBudgetExists==1?  Number(data.originalBudgetApportionAmount).toFixed(2) :data.originalBudgetApportionAmount ? Number(data.originalBudgetApportionAmount).toFixed(2) : '-'
                }}
              </div>
            </div>
            <div class="m-row" v-if="inputForm.unitPriceType=='2'">
              <div class="m-row-text">已请款金额(元)</div>
              <div class="m-row-content">{{
                  Number(data.requestAmount).toFixed(2)
                }}
              </div>
            </div>
            <div class="m-row" v-if="inputForm.unitPriceType=='2'">
              <div class="m-row-text">调整预算分摊金额(元)</div>
              <div class="m-row-content">{{ Number(data.adjustBudgetApportionAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row" v-if="inputForm.unitPriceType=='2'">
              <div class="m-row-text">调整后预算分摊金额(元)</div>
              <div class="m-row-content">{{
                  data.isBudgetExists == 1 ? Number((data.budgetAmount || 0) - (data.budgetUsedAmount || 0) - (data.budgetApportionAmount || 0)).toFixed(2) : '-'
                }}
              </div>
            </div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="单价信息" name="5" v-if="inputForm.unitPriceType === '3' && inputForm.isHq === '0'">
        <div class="m-form" v-for="(data, index) in inputForm.unitPriceList" :key="index">
          <div class="m-row">
            <div class="m-row-text">单价名称</div>
            <div class="m-row-content">{{ data.name }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">单位</div>
            <div class="m-row-content">{{ data.unit }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">单价/比例(%)</div>
            <div class="m-row-content">
              {{ data.unitCategory === '2' ? Number(data.unitPrice).toFixed(2) : Number(data.unitPrice).toFixed(6) }}
            </div>
          </div>
          <div class="m-row">
            <div class="m-row-text">备注</div>
            <div class="m-row-content large-content">{{ data.remarks }}</div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../components/processRecord/processRecord";
import TaskService from "../../../../api/flowable/TaskService";
import ProcessService from "../../../../api/flowable/ProcessService";
import QueryInfoService from '@/api/system/queryInfoService'
import Decimal from "decimal.js";
import Vue from "vue";
import flowSettingService from "../../../../api/sys/flowSettingService";

export default {
  name: "eventAdjust",
  data() {
    return {
      activeNames: ['1', '2', '3','4','5'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        id: '',
        eventCode: '',
        eventName: '',
        eventType: '',
        eventTypeName: '',
        unitPriceType: '',
        unitPriceTypeName: '',
        mainstay: '',
        projectName: '',
        paymentCompanyName: '',
        eventAmount: '',
        supplierName: '',
        effectiveStartDate: '',
        effectiveEndDate: '',
        createByName: '',
        createDeptName: '',
        createDate: '',
        remarks: '',
        attachList: [],
        unitPriceList: [],
        budgetControl: '',
        budgetControlName: '',
        specialProjectName: '',
        costBudgetDTOList: [],
      },
      adjustTypeList: [
        {name: 'paymentCompanyId', label: '付款公司'},
        {name: 'supplierType', label: '收款人类型'},
        {name: 'supplierId', label: '收款人名称'},
        {name: 'effectiveStartDate', label: '非合同事项单期限起'},
        {name: 'effectiveEndDate', label: '非合同事项单期限止'},
        {name: 'eventAmount', label: '事项单应付款金额'}
      ],
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    // let id ='1872464429354942465'
    // let id = '1872478399860146177'
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if (!window.matchMedia("(orientation:portrait)").matches) {
      dd.device.screen.resetView({
        onSuccess: function (result) {
        },
        onFail: function (err) {
        }
      });
    }
  },
  methods: {
    getAdjustTypeName(value){
      let name = ''
      this.adjustTypeList.forEach(item => {
        if(item.name == value){
          name = item.label
        }
      })
      return name
    },
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.inputForm.id = id
      this.$flow.queryById(id, '/payment/costEventAdjust/queryById').then(({data}) => {
        this.inputForm = data
        this.inputForm.mainstayObjName = data.mainstayType === '1' ? data.mainstayDeptName : data.mainstayCompanyName
        // 费用承担对象
        // if (data.mainstayType == '1') {
        //   this.inputForm.mainstay = data.mainstayCompanyName + '-' + data.mainstayDeptName
        // } else {
        //   this.inputForm.mainstay = data.mainstayCompanyName
        // }
        // 金额校验
        this.inputForm.eventAmount = Number(this.inputForm.eventAmount).toFixed(2)
        // 日期校验
        this.inputForm.createDate = this.inputForm.createDate.slice(0, 10)
        // 查询字典
        this.getDict([
          ['cost_event_type', 'eventType'],
          ['cost_event_price_type', 'unitPriceType'],
          ['cost_entity_type', 'mainstayType'],
          ['cost_supplier_type', 'supplierType'],
          ['cost_contract_budget_control', 'budgetControl'],
        ])
        // 百分比校验
        // this.inputForm.unitPriceList.forEach(item => {
        //   if (item.unitCategory === '2') {
        //     item.unitPrice = Decimal(item.unitPrice).mul(100).toFixed(2, Decimal.ROUND_HALF_UP)
        //   }
        // })
      }).catch(e => {
        console.log(e)
      })
    },
    // 数据字典获取
    getDict(dicts) {
      dicts.map(([dictType, formField]) => {
        new QueryInfoService().getDictMap().then(({data}) => {
          this.$set(this.inputForm, `${formField}Name`, data[dictType].find(item => item.value == this.inputForm[formField]).label);
        }).catch(e => {
          console.log(e)
        })
      });
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then( async () => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        let sendBy = ''
        let sendByDeptId = ''
        let sendByCompanyId = ''
        if(this.inputForm.flowStatus === 1) {
          sendBy = Vue.cookie.get('userId');
          const res1 = await new flowSettingService().queryUser(sendBy)
          sendByDeptId = res1.data.officeDTO.id
          sendByCompanyId = res1.data.companyDTO.id
        } else {
          const res3 = await new TaskService().queryByProcInsId(this.inputForm.procInsId)
          sendBy = res3.data.createBy
          sendByDeptId = res3.data.createDept
          sendByCompanyId = res3.data.createCompany
        }
        let createByDeptId = ''
        let createByCompanyId = ''
        const res2 = await new flowSettingService().queryUser(this.inputForm.createBy.id)
        createByDeptId = res2.data.officeDTO.id
        createByCompanyId = res2.data.companyDTO.id
        vars = {
          sendBy: sendBy,
          sendByDeptId: sendByDeptId,
          sendByCompanyId: sendByCompanyId,
          createBy: this.inputForm.createBy.id,
          createByDeptId: createByDeptId,
          createByCompanyId: createByCompanyId,
          paymentCompanyId: this.inputForm.adjustPaymentCompanyId,
        }
        // vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/payment/costEventAdjust/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey
          }
          _this.$flow.startFlow(form, '/payment/costEventAdjust/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.m-form {
  width: 100%;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  /*border-bottom: 1px solid #eee;*/
  padding-left: 16px;
  margin-bottom: 10px;
}

.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100%);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row:last-child {
  border-bottom: 1px solid #eee;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #dedede;*/
}

.m-row-content {
  width: calc(100% - 110px);
  color: black;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100% - 110px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>
